__turbopack_context__.v({
  "className": "r9lbzW_className",
  "variable": "r9lbzW_variable",
});
